import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEntitlements } from "../../context/EntitlementsContext";

export function BillingSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const { refreshEntitlements } = useEntitlements();

  useEffect(() => {
    // Refresh entitlements after successful purchase
    console.log("Payment successful, session ID:", sessionId);
    refreshEntitlements();
    
    // Redirect to dashboard after 3 seconds
    const timeout = setTimeout(() => {
      navigate("/dashboard");
    }, 3000);

    return () => clearTimeout(timeout);
  }, [sessionId, navigate, refreshEntitlements]);

  return (
    <div className="min-h-screen flex items-center justify-center surface-page px-4">
      <div className="max-w-md w-full surface-card rounded-2xl shadow-xl p-8 text-center">
        {/* Success Icon */}
        <div className="mx-auto w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-4">
          <svg className="w-10 h-10 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Welcome to Elite! 🎉
        </h1>

        {/* Message */}
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Your subscription has been activated successfully. You now have access to all Elite features including:
        </p>

        {/* Features List */}
        <ul className="text-left space-y-2 mb-6">
          {[
            "See who liked you",
            "More likes",
            "Priority matching",
            "Elite badge on your profile",
            "Ad-free experience",
          ].map((feature, index) => (
            <li key={index} className="flex items-center text-gray-700 dark:text-gray-300">
              <svg className="w-5 h-5 mr-3 text-rose-600 dark:text-rose-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              {feature}
            </li>
          ))}
        </ul>

        {/* Action Button */}
        <button
          onClick={() => navigate("/dashboard")}
          className="w-full bg-gradient-to-r from-rose-600 to-pink-600 text-white font-semibold py-3 px-6 rounded-full hover:from-rose-700 hover:to-pink-700 transition-all duration-200 shadow-md hover:shadow-lg"
        >
          Go to Dashboard
        </button>

        <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
          Redirecting automatically in 3 seconds...
        </p>
      </div>
    </div>
  );
}
